import { DatePickerProps } from '@mui/lab';
import { TextFieldProps } from '@mui/material';
import {
  DatePickerSlotProps,
  DatePickerSlots,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

export const DatePicker = ({
  label,
  datePickerProps,
  field,
  value,
  slots,
  slotProps,
  errorMsg,
  size,
  onChange,
  disabled = false,
}: {
  label?: string | null;
  datePickerProps?: Partial<DatePickerProps<Dayjs>>;
  field?: ControllerRenderProps<FieldValues, string>;
  value?: Dayjs | null;
  /** Forwarded from FormDatePicker `datePickerProps.slots` (e.g. openPickerIcon). */
  slots?: DatePickerSlots<Dayjs>;
  slotProps?: DatePickerSlotProps<Dayjs, false> | undefined;
  errorMsg?: string;
  size?: TextFieldProps['size'];
  onChange: (date: Dayjs | null) => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <MuiDatePicker
      label={label}
      {...datePickerProps}
      {...field}
      value={value}
      disabled={disabled}
      // This wrapper controls `open` itself and forces an open-on-click handler below, so MUI's
      // own disabled guard isn't enough on its own — keep the picker shut while disabled.
      open={disabled ? false : open}
      onChange={onChange}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disableOpenPicker={false}
      desktopModeMediaQuery="@media(min-width:0px)"
      sx={{ '& *': { cursor: disabled ? 'default' : 'pointer' }, width: '100%' }}
      slots={slots}
      slotProps={{
        ...slotProps,
        textField: {
          size,
          ...slotProps?.textField,
          error: !!errorMsg,
          onClick: disabled ? undefined : () => setOpen(true),
          onMouseDown: (e) => {
            e.preventDefault();
          },
          inputProps: {
            readOnly: true,
            style: {
              userSelect: 'none',
            },
          },
        },
        openPickerButton: {
          ...(slotProps?.openPickerButton || {}),
          disabled,
          disableRipple: true,
          sx: {
            display: 'flex !important',
            alignItems: 'center',
            height: '100%',
            '& .MuiSvgIcon-root': {
              fontSize: '1.5rem',
            },
            ...(typeof slotProps?.openPickerButton === 'object'
              ? slotProps.openPickerButton?.sx
              : undefined),
          },
        },
      }}
    />
  );
};
